import { v4 as uuidv4 } from 'uuid';
import OfflineController from '@/assets/ts/controller/OfflineController';
import { EstruturasOffline } from '../../interfaces/Offline';
import SnackbarUtils from "@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils";

class EstruturaRepository {

  public static async getEstruturas(): Promise<EstruturasOffline[]> {
    try {
      const db = OfflineController.getDB();
      const estruturas = await new Promise<any[]>((resolve, reject) => {
        db.transaction((tx) => {
          tx.executeSql('SELECT * FROM ESTRUTURAM', [], (tx, res) => {
            const estruturasRow = [];
            for (let i = 0; i < res.rows.length; i++) {
              estruturasRow.push(res.rows.item(i));
            }
            resolve(estruturasRow);
          });
        });
      });
      return estruturas;
    } catch (err) {
      SnackbarUtils.showMessage(err as string, SnackbarUtils.TYPE_ERROR);
      throw err;
    }
  }

  public static async setEstruturas(
    estruturas: EstruturasOffline[]
  ): Promise<any> {
    try {

      const db = OfflineController.getDB();

      const result = await new Promise((resolve, reject) => {
        db.transaction(
          (tx) => {
            estruturas.forEach(
              ({ NRESTRUTURAM, NMESTRUTURA, IDTIPOESTRUTURA }) => {
                const NRESTRUTURAMOFF = uuidv4();

                tx.executeSql(
                  'INSERT INTO ESTRUTURAM (NRESTRUTURAMOFF, NRESTRUTURAM, NMESTRUTURA, IDTIPOESTRUTURA) VALUES (?, ?, ?, ?)',
                  [NRESTRUTURAMOFF, NRESTRUTURAM, NMESTRUTURA, IDTIPOESTRUTURA]
                );
              }
            );
          },
          (error) => {
            reject(error);
          },
          () => {
            resolve([]);
          }
        );
      });

      return result;
    } catch (err) {
      SnackbarUtils.showMessage(err as string, SnackbarUtils.TYPE_ERROR);
      throw err;
    }
  }

  public static async deleteEstruturas(): Promise<any> {
    try {
      const db = OfflineController.getDB();
      const result = await new Promise((resolve, reject) => {
        db.transaction(
          (tx) => {
            tx.executeSql('DELETE FROM ESTRUTURAM');
          },
          (error) => {
            reject(error);
          },
          () => {
            resolve('');
          }
        );
      });

      return result;
    } catch (err) {
      SnackbarUtils.showMessage(err as string, SnackbarUtils.TYPE_ERROR);
      throw err;
    }
  }
}

export default EstruturaRepository;
